export const errorMessage = (e: unknown): string =>
  e instanceof Error ? e.message : String(e);

export const isUUID = (term: string): boolean =>
  /^[a-f\d]{8}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{12}$/i.test(term);
